
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    DELETE_CLIP_REQUEST_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientMutation } from 'Core/data/GraphQLApi';
import { deleteClipRequestResult } from 'Redux/actions';

function* deleteClipRequest({ payload }) {
    
    try {
        let QUERY = `
            mutation deleteClipRequest ($id: String!) {
                result: deleteClipRequest (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(deleteClipRequestResult({ delete: data.result }))

    } catch (exc) {
        yield put(deleteClipRequestResult({ delete: false, error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/deleteClipRequest/redux/saga",
            "deleteClipRequest",
        )
    }
}

function* watchMethods() {
    yield takeEvery(DELETE_CLIP_REQUEST_REQUEST, deleteClipRequest);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}